import { apiCaller } from 'util/apiCaller';

const fetchData = function* fetchData(configAPI, getName) {
  const {
    urlData, method, value, apiType, params, isShowMessage
  } = configAPI;
  const newConfigAPI = {
    url: urlData,
    method,
    data: value,
    params,
    apiType,
    isShowMessage
  };
  const data = apiCaller(newConfigAPI, getName);
  return yield data || [];
};
export default fetchData;
